import { render, staticRenderFns } from "./comment-base-avatar.vue?vue&type=template&id=5ca34380&"
import script from "./comment-base-avatar.vue?vue&type=script&lang=js&"
export * from "./comment-base-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports